import React from "react";
import { UseFormRegisterReturn, FieldError } from "react-hook-form";

interface FormTextAreaProps {
  label?: string;
  description?: string;
  rows?: number;
  maxLength?: number;
  showCounter?: boolean;
  placeholder?: string;
  error?: FieldError;
  value?: string;
  className?: string;
  register?: UseFormRegisterReturn;
}

export function FormTextArea({
  label,
  description,
  rows = 4,
  maxLength,
  showCounter = false,
  placeholder,
  error,
  value = "",
  className = "",
  register,
}: FormTextAreaProps) {
  return (
    <div className={className}>
      {label && (
        <h2 className="text-xl font-bold text-gray-bb-1 mb-4">{label}</h2>
      )}
      {description && (
        <p className="text-gray-bb-2 mb-6 font-bold"
           dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      <textarea
        {...register}
        rows={rows}
        maxLength={maxLength}
        className={`w-full border rounded-lg p-3 focus:ring-2 focus:ring-blue-bb focus:border-transparent resize-none ${
          error ? "border-red-500" : "border-gray-bb-4"
        }`}
        placeholder={placeholder}
      />

      {showCounter && maxLength && (
        <div className="text-right text-sm text-gray-bb-2 mt-2">
          Caracteres: {value?.length || 0}/{maxLength}
        </div>
      )}
      {error && (
        <p className="text-red-500 text-sm mt-1">{error.message}</p>
      )}
    </div>
  );
}